export default __webpack_public_path__ + "static/media/39.ceab8640.jpg";